
import { Phone, Mail } from "lucide-react";

export const AboutContact = () => {
  return (
    <section className="bg-secondary/10 rounded-2xl p-8 space-y-6">
      <h2 className="text-3xl font-semibold text-center">Contact Us</h2>
      <div className="max-w-xl mx-auto space-y-4">
        <div className="flex items-center gap-3 justify-center">
          <Phone className="w-5 h-5 text-primary" />
          <p className="text-muted-foreground">
            Call us at <a href="tel:+14059726779" className="text-primary hover:underline">(405) 972-6779</a>
          </p>
        </div>
        <div className="flex items-center gap-3 justify-center">
          <Mail className="w-5 h-5 text-primary" />
          <p className="text-muted-foreground">
            Email us at <a href="mailto:support@homeprosokc.com" className="text-primary hover:underline">support@homeprosokc.com</a>
          </p>
        </div>
      </div>
    </section>
  );
};
